<template>
  <div class="wrapper">
    <div class="form">
      <van-notice-bar v-if="status != '3'" :text="statusMap[status]" />
      <van-form @submit="onSubmit">
        <div class="formWrapper">
          <div class="panel" v-if="status == '3'">
            <div class="title">未通过原因</div>
            <div class="discription" style="color: red">
              <van-icon name="warning-o" /> {{ this.formData.failReason }}
            </div>
          </div>
          <div class="panel">
            <div class="title">激活码信息</div>
            <van-field :readonly="status != 3 || !isEdit" v-model="formData.code" name="code" label="激活码" required
              placeholder="请输入激活码" :rules="[{ required: true, message: '请填写激活码' }]">
              <van-icon v-if="status == 3" @click="codeScan" slot="right-icon" name="scan" />
            </van-field>
            <van-field :readonly="true" v-model="formData.groupName" name="groupName" label="商品名称" left-icon="warning-o"
              rows="2" type="textarea" @click-left-icon="showMark" required placeholder="请输入商品名称"
              :rules="[{ required: true, message: '请填写商品名称' }]" />
          </div>
          <div class="panel">
            <div class="title">产品信息</div>
            <van-field :readonly="status != 3 || !isEdit" clickable name="picker" :value="brandName" required label="品牌"
              :rules="[{ required: true, message: '请选择品牌' }]" placeholder="点击选品牌" @click="showPicker = true" />
            <van-field readonly v-model="formData.model" name="model" label="型号" required placeholder="请输入型号"
              @click="modelItemClick" :rules="[{ required: true, message: '请填写型号' }]" />
            <van-popup v-model="showVersionPicker" round position="bottom">
              <van-picker show-toolbar title="选择型号" :columns="filterVersionCol" @cancel="showVersionPicker = false"
                @confirm="onConfirm3">
                <slot slot="title">
                  <van-search style="padding: 0" v-model="searchValue" placeholder="输入机型" />
                </slot>
                <template #option="item">
                  <div @click="pickerItemClick(item)">{{ item }}</div>
                </template>
              </van-picker>
            </van-popup>
            <van-field :readonly="status != 3 || !isEdit" v-model="formData.memory" name="memory" label="内存" required
              placeholder="请输入内存" :rules="[{ required: true, message: '请填写内存' }]" />
            <van-field v-if="status != 3 || !isEdit" :readonly="true" :value="maskserialNum" name="serialNum" label="串号"
              required>
              <van-icon v-if="status == 3 || !isEdit" @click="serialScan" slot="right-icon" name="scan" />
            </van-field>
            <van-field v-if="!(status != 3 || !isEdit)" :readonly="status != 3 || !isEdit" v-model="formData.serialNum"
              name="serialNum" label="串号" required placeholder="请输入串号" :rules="[{ required: true, message: '请填写串号' }]">
              <van-icon v-if="status == 3 || !isEdit" @click="serialScan" slot="right-icon" name="scan" />
            </van-field>
          </div>
          <div class="panel">
            <div class="title">用户信息</div>
            <van-field :readonly="status != 3 || !isEdit" v-model="formData.userName" name="userName" label="姓名"
              required placeholder="请输入姓名" :rules="[{ required: true, message: '请填写姓名' }]" />
            <van-field v-if="status != 3 || !isEdit" :readonly="true" :value="maskPhone" type="tel" name="userPhone"
              label="手机号" required />
            <van-field v-if="!(status != 3 || !isEdit)" :readonly="status != 3 || !isEdit" type="tel" name="userPhone"
              v-model="formData.userPhone" label="手机号" required :maxlength="11" placeholder="请输入手机号" :rules="[
                { required: true, message: '请填写手机号' },
                {
                  message: '手机号码格式错误,请重新输入',
                  pattern: /0?(13|14|15|16|17|18|19)[0-9]{9}/,
                },
              ]" />
            <van-field class="picker-field" :class="purchasTime && 'picker-inputed'" clickable name="picker"
              :readonly="status != 3 || !isEdit" :value="purchasTime" required label="购机时间"
              :rules="[{ required: true, message: '请选择购机时间' }]" placeholder="点击选择购机时间" @click="showTime = true" />
            <van-field v-model="formData.money" :type="status != 3 || !isEdit ? 'string' : 'number'" name="money"
              :readonly="status != 3 || !isEdit" label="购机价格" required placeholder="请输入购机价格"
              :rules="[{ required: true, message: '请填写购机价格' }]" />
          </div>
          <div class="panel">
            <div class="title">门店信息</div>
            <van-field v-model="formData.sellName" :readonly="status != 3 || !isEdit" name="sellName" label="销售员姓名"
              required placeholder="请输入销售员姓名" :rules="[{ required: true, message: '请填写销售员姓名' }]">
            </van-field>
            <van-field v-model="formData.sellPhone" type="tel" :readonly="status != 3 || !isEdit" name="sellPhone"
              label="销售员手机号" :maxlength="11" required placeholder="请输入销售员手机号" :rules="[
                { required: true, message: '请填写销售员手机号' },
                {
                  message: '手机号码格式错误,请重新输入',
                  pattern: /0?(13|14|15|16|17|18|19)[0-9]{9}/,
                },
              ]" />
          </div>
          <div class="panel">
            <div class="title">凭证信息</div>
            <div class="discription">
              提示:
              <p>1、完整主屏幕，常亮状态下*#06#显示出串号（手机务必照全）</p>
              <p>
                2、完整购机凭证盖门店销售章，需填写用户姓名、电话、日期、机型、串号、价格，不可遮挡；
              </p>
              <p>
                3、完整保修卡盖章，需填写用户姓名、电话、日期、串码标，不可遮挡；
              </p>
              <p>4、百度搜索显示北京时间。</p>
            </div>
            <van-button v-if="codeCertificate" style="width: 100%" @click="
                (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  openPreview([codeCertificate]);
                }
              ">
              预览图片
            </van-button>
            <van-uploader accept="image/*" :disabled="!isEdit" :after-read="afterRead" :max-size="20 * 1024 * 1024"
              @oversize="overSizeTip">
              <img v-if="codeCertificate" style="width: 100%" :src="codeCertificate" />
              <van-button v-else class="upladerBtn" icon="plus" type="primary"></van-button>
            </van-uploader>
          </div>
          <div class="panel">
            <div class="title">
              如需补交照片资料，请点击下方上传照片后提交：
            </div>
            <van-button v-if="codeCertificate2" style="width: 100%" @click="
                (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  openPreview([codeCertificate2]);
                }
              ">
              预览图片
            </van-button>
            <van-uploader accept="image/*" :disabled="!isEdit" :after-read="afterRead2" :max-size="20 * 1024 * 1024"
              @oversize="overSizeTip">
              <img v-if="codeCertificate2" style="width: 100%" :src="codeCertificate2" />
              <van-button v-else class="upladerBtn supplementImg" icon="plus" type="primary"></van-button>
            </van-uploader>
          </div>
          <div class="panel">
            <!-- <div class="title">
              第三张凭证照片（如需要）：
            </div> -->
            <van-button v-if="codeCertificate3" style="width: 100%" @click="
                (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  openPreview([codeCertificate3]);
                }
              ">
              预览图片
            </van-button>
            <van-uploader accept="image/*" :disabled="!isEdit" :after-read="afterRead3" :max-size="20 * 1024 * 1024"
              @oversize="overSizeTip">
              <img v-if="codeCertificate3" style="width: 100%" :src="codeCertificate3" />
              <van-button v-else class="upladerBtn supplementImg" icon="plus" type="primary"></van-button>
            </van-uploader>
          </div>
          <div class="panel" v-if="exchangePicture">
            <div class="title">换机照片</div>
            <van-button style="width: 100%" @click="
                (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  openPreview([exchangePicture]);
                }
              ">
              预览图片
            </van-button>
            <img style="width: 100%" :src="exchangePicture" />
          </div>
        </div>
        <div v-if="status == 3" style="margin: 16px">
          <van-button v-if="isEdit" round block type="danger" native-type="submit">提交</van-button>
        </div>
      </van-form>
      <div v-if="status == 3" style="margin: 16px">
        <van-button v-if="!isEdit" round block type="danger" @click="onEdit">修改信息</van-button>
      </div>
      <div v-if="status == 1" style="margin: 16px">
        <van-button @click="linkTo" round block type="danger">报修</van-button>
      </div>
      <div v-if="status == 1 && !isChange" style="margin: 16px">
        <van-button @click="
            $router.push({
              path: '/exchange',
              query: {
                code,
              },
            })
          " round block type="danger">更换串号</van-button>
      </div>
      <div v-if="status == 4 || status == 5" style="margin: 16px">
        <van-button @click="linkTo" round block type="danger">查看报修订单</van-button>
      </div>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="brandList" value-key="brandName" @confirm="onConfirm"
          @cancel="showPicker = false">
        </van-picker>
      </van-popup>
      <van-popup v-model="showTime" position="bottom">
        <van-datetime-picker v-model="formData.purchasTime" type="date" @confirm="onConfirm2" @cancel="showTime = false"
          title="选择年月日" />
      </van-popup>
    </div>
    <loadingMask :isShow="showLoding" />
  </div>
</template>

<script>
  import {
    uploadImg,
    updateUserInfo,
    getBrandList,
    getUserInfo,
    getVersionList,
  } from "@/api";
  import {
    baseURL
  } from "@/config";
  import loadingMask from "@/components/loadingMask.vue";
  import {
    statusMap,
    checkImgFun
  } from "@/utils/common.js";
  import dayjs from "dayjs";
  import {
    getScanCode
  } from "@/utils/wxSDK";
  import {
    openPreview
  } from "@/utils";
  import {
    Dialog
  } from "vant";
  export default {
    name: "codeDetail",
    components: {
      loadingMask,
    },
    data() {
      return {
        baseURL,
        formData: {
          code: "",
          codeCertificate: "",
          serialNum: "",
          userName: "",
          userPhone: "",
          money: "",
          brandId: "",
          groupMark: "",
          purchasTime: new Date(),
          sellName: "",
          sellPhone: "",
          memory: "",
          model: "",
        },
        searchValue: "",
        showVersionPicker: false,
        isEdit: false,
        money: "",
        codeCertificate: "",
        codeCertificate2: "",
        codeCertificate3: "",
        exchangePicture: "",
        purchasTime: dayjs().format("YYYY-M-D"),
        code: this.$route.query.code,
        codeId: "",
        status: "",
        statusMap,
        brandName: "",
        brandList: [],
        showLoding: false,
        showPicker: false,
        showTime: false,
        isChange: false,
        versionList: [],
      };
    },
    mounted() {
      window.document.title = "激活码";
      this.getUserInfoFun();
      this.getVersionListFun();
    },
    computed: {
      maskPhone: function() {
        return this.numberFormatter(this.formData.userPhone, 2);
      },
      maskserialNum: function() {
        return this.numberFormatter(this.formData.serialNum, 1);
      },
      filterVersionCol: function() {
        return this.searchValue ?
          this.versionList.filter((v) => v.includes(this.searchValue)) :
          this.versionList;
      },
    },
    methods: {
      openPreview,
      modelItemClick() {
        if (this.status != 3 || !this.isEdit) return;
        this.showVersionPicker = true;
        this.searchValue = "";
      },
      numberFormatter(value, type) {
        console.log(1123, value);
        if (type === 1) {
          return value.replace(/\w{4}$/, "****");
        }
        if (type === 2) {
          return value.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
        }
      },
      showMark() {
        Dialog.alert({
          title: "商品描述",
          message: this.formData.groupMark,
          theme: "round-button",
        }).then(() => {
          // on close
        });
      },
      onEdit() {
        this.isEdit = true;
        this.formData.money = this.money;
      },
      codeScan() {
        getScanCode().then((res) => {
          this.formData.code = res;
        });
      },
      serialScan() {
        getScanCode().then((res) => {
          this.formData.serialNum = res;
        });
      },
      overSizeTip() {
        this.$toast("上传图片不能超过20M");
      },
      linkTo() {
        this.$router.push({
          path: "/guarantee",
          query: {
            codeId: this.codeId, // 激活码主键id
            code: this.code, // 激活码数字
            codeStatus: this.status, // 是否激活 0未激活1已激活 2待审核 3未通过
          },
        });
      },
      onSubmit(e) {
        this.showLoding = true;
        let data = JSON.parse(JSON.stringify(this.formData));
        data.purchasTime = this.purchasTime;
        updateUserInfo(data).then((res) => {
          const response = res.data;
          if (response.code === "200") {
            this.$toast.success({
              message: "信息已提交，等待工作人员审核",
              duration: 5000,
            });
          } else {
            this.$toast.fail(response.msg);
          }
          this.showLoding = false;
        });
      },
      onConfirm(value) {
        this.brandName = value.brandName;
        this.formData.brandId = value.brandId;
        this.showPicker = false;
      },
      onConfirm2(value) {
        this.formData.purchasTime = value;
        this.purchasTime = dayjs(value).format("YYYY-M-D");
        this.showTime = false;
      },
      onConfirm3() {
        if (!this.searchValue) {
          this.$toast("请输入型号");
          return;
        }
        this.formData.model = this.searchValue;
        this.showVersionPicker = false;
      },
      pickerItemClick(item) {
        this.searchValue = item;
      },
      getVersionListFun() {
        getVersionList().then((res) => {
          const response = res.data;
          if (response.code === "200") {
            this.versionList = response.data.map((v) => {
              return v.version;
            });
          }
        });
      },
      async getUserInfoFun() {
        await getBrandList().then((res) => {
          const response = res.data;
          if (response.code === "200") {
            this.brandList = response.data;
          }
        });
        getUserInfo({
          keyword: this.code,
        }).then((res) => {
          const response = res.data;
          if (response.code === "200") {
            this.status = response.data[0].status;
            this.brandName = response.data[0].brandName;
            this.money = response.data[0].money;
            response.data[0].money = "****";
            checkImgFun(response.data[0].codeCertificate).then((url) => {
              this.codeCertificate = url;
            });
            checkImgFun(response.data[0].codeCertificate2).then((url) => {
              this.codeCertificate2 = url;
            });
            checkImgFun(response.data[0].codeCertificate3).then((url) => {
              this.codeCertificate3 = url;
            });
            checkImgFun(response.data[0].exchangePicture).then((url) => {
              this.exchangePicture = url;
            });
            this.purchasTime = dayjs(response.data[0].purchasTime).format(
              "YYYY-M-D"
            );
            this.codeId = response.data[0].codeId;
            this.isChange = response.data[0].isChange == 1;
            this.formData = response.data[0];
          }
        });
      },
      afterRead(file) {
        this.showLoding = true;
        var formData = new FormData();
        formData.append("picture", file.file);
        formData.append("code", this.code);
        formData.append("name", "code_certificate");
        uploadImg(formData)
          .then((res) => {
            const response = res.data;
            if (response.code === "200") {
              this.formData.codeCertificate = response.data;
              checkImgFun(response.data).then((url) => {
                this.codeCertificate = url;
              });
              this.$toast.success("上传成功");
            } else {
              this.$toast.fail(response.msg);
            }
            this.showLoding = false;
          })
          .catch(() => {
            this.$toast.fail("上传失败,请重新上传");
            this.showLoding = false;
          });
      },
      afterRead2(file) {
        console.log(file);
        this.showLoding = true;
        var formData = new FormData();
        formData.append("picture", file.file);
        formData.append("code", this.code);
        formData.append("name", "code_certificate2");
        uploadImg(formData)
          .then((res) => {
            const response = res.data;
            if (response.code === "200") {
              this.formData.codeCertificate2 = response.data;
              checkImgFun(response.data).then((url) => {
                this.codeCertificate2 = url;
              });
              this.$toast.success("上传成功");
            } else {
              this.$toast.fail(response.msg);
            }
            this.showLoding = false;
          })
          .catch(() => {
            this.$toast.fail("上传失败,请重新上传");
            this.showLoding = false;
          });
      },
      afterRead3(file) {
        console.log(file);
        this.showLoding = true;
        var formData = new FormData();
        formData.append("picture", file.file);
        formData.append("code", this.code);
        formData.append("name", "code_certificate3");
        uploadImg(formData)
          .then((res) => {
            const response = res.data;
            if (response.code === "200") {
              this.formData.codeCertificate3 = response.data;
              checkImgFun(response.data).then((url) => {
                this.codeCertificate3 = url;
              });
              this.$toast.success("上传成功");
            } else {
              this.$toast.fail(response.msg);
            }
            this.showLoding = false;
          })
          .catch(() => {
            this.$toast.fail("上传失败,请重新上传");
            this.showLoding = false;
          });
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
  .wrapper {
    background: url("https://www.servicefun.cn/static/img/bg.png") no-repeat;
    overflow: auto;
    background-size: 100%;
    background-color: #f0f0f0;

    .picker-field.picker-inputed {
      /deep/ .van-field__control {
        color: #323233;
        -webkit-text-fill-color: #323233;
      }
    }

    .picker-field {
      /deep/ .van-cell__title {
        position: absolute;
        width: 100%;
        z-index: 1;
        color: #646566;
      }

      /deep/ .van-cell__value {
        color: #8e8e8e;
        padding-left: 100px;
      }

      /deep/ .van-field__control {
        color: #8e8e8e;
        -webkit-text-fill-color: #8e8e8e;
      }
    }

    .formWrapper {
      width: 340px;
      background: #fff;
      margin: 0 auto;
      margin-top: 36px;
      border-radius: 10px;
      overflow: hidden;
      padding-bottom: 20px;
    }

    .panel {
      .title {
        padding: 10px 16px;
      }

      /deep/ .van-uploader {
        width: 300px;
        padding: 10px 16px;
      }

      .upladerBtn {
        border: none;
        width: 300px;
        font-size: 40px;
        height: 240px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url(https://www.servicefun.cn/static/img/exrample.jpeg);
      }

      .upladerBtn.supplementImg {
        background-image: none;
        background-color: #e2e2e2;
      }
    }

    .discription {
      padding: 10px 16px;
      font-size: 12px;
      color: #908c8c;

      p {
        margin-top: 6px;
        line-height: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/codeDetail/index.vue